import axios from 'axios';
// src/services/apiService.js
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const login = async (email, password) => {
  try {
    const data = await axios.post(`${BASE_URL}/login`, { email, password });
    return data;
  } catch (error) {
    console.error('Error logging in:', error);
    throw error;
  }
};

export const logout = async () => {
  try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${BASE_URL}/logout`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });

      if (response.data.status === 'Sucess') {
        localStorage.removeItem('token');
        localStorage.removeItem('username');
        localStorage.removeItem('lastname');
        localStorage.removeItem('is_admin');
        localStorage.removeItem('imageurl');
        return response;
      } else {
        console.error('Logout failed');
        return response;
      }
  } catch (error) {
    console.error('Logout:', error);
    throw error;
  }
};

export const dataSource = async () => {
  try {
      const token = localStorage.getItem('token');
      const data = await axios.get(`${BASE_URL}/data-source`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });

    return data;
  } catch (error) {
    console.error('Fetch datasources:', error);
    throw error;
  }
};

export const deleteDataSource = async (Id) =>{
    try{
        const token = localStorage.getItem('token');
        return await axios.delete(`${BASE_URL}/deletedatasource/${Id}`, {
          headers: { 'Authorization': `Bearer ${token}` }
        }); 
    } catch(error){
        console.log('error while calling deleteDataSource api', error);
    }
}

export const storeDatasource = async (data) => {
    try{
        const token = localStorage.getItem("token");
        return await axios.post(`${BASE_URL}/storedatasource`,
          data,  // Send formData directly here
          {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`
            }
          }
        );
    } catch(error){
        console.log('error while calling storeDatasource api', error);
    }
}

export const uploadDatasource = async (data) => {
    try{
        const token = localStorage.getItem("token");
        return await axios.post(`${BASE_URL}/uploaddatasource`,
            data,  // Send formData directly here
        {
          headers: {
            "Content-Type": "multipart/form-data",
            'Authorization': `Bearer ${token}`
          }
        }
      );
    } catch(error){
        console.log('error while calling uploadDatasource api', error);
    }
}

export const searchDatasource = async (data) => {
  try{
      const token = localStorage.getItem("token");
      return await axios.post(`${BASE_URL}/searchdatasource`,
        data,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          }
        }
      );
  } catch(error){
      console.log('error while calling Search Datasource api', error);
  }
}

export const storeUser = async (data) => {
    try{
        const token = localStorage.getItem("token");
          return await axios.post(`${BASE_URL}/storeuser`,
              data,  // Send formData directly here
              {
                headers: {
                  'Content-Type': 'application/json',
                  'Authorization': `Bearer ${token}`
                }
              }
            );
    } catch(error){
        console.log('error while calling addUser api', error);
    }
}

export const registerUser = async (data) => {
    try{
        return await axios.post(`${BASE_URL}/register`,
              data,  // Send formData directly here
              {
                headers: {
                  'Content-Type': 'application/json',
                }
              }
            );
    } catch(error){
        console.log('error while calling registerUser api', error);
    }
}

export const userMaster = async () => {
    try {
        const token = localStorage.getItem('token');
        const data = await axios.get(`${BASE_URL}/users`, {
          headers: { 'Authorization': `Bearer ${token}` }
        });
  
      return data;
    } catch (error) {
      console.error('Fetch Users:', error);
      throw error;
    }
}

export const editUser = async (Id) =>{
  try{
      const token = localStorage.getItem('token');
      return await axios.get(`${BASE_URL}/editUser/${Id}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      }); 
  } catch(error){
      console.log('error while calling deleteDataSource api', error);
  }
}


export const updateUser = async (user, id) => {
  try{
      const token = localStorage.getItem("token");
        return await axios.post(`${BASE_URL}/updateUser/${id}`,
          user,  // Send formData directly here
            {
              headers: {
                'Authorization': `Bearer ${token}`
              }
            }
          );
  } catch(error){
      console.log('error while calling addUser api', error);
  }
}


export const deleteUser = async (Id) =>{
  try{
      const token = localStorage.getItem('token');
      return await axios.delete(`${BASE_URL}/deleteuser/${Id}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      }); 
  } catch(error){
      console.log('error while calling deleteUser api', error);
  }
}


export const getHistory = async () => {
  try {
      const token = localStorage.getItem('token');
      const data = await axios.get(`${BASE_URL}/gethistory`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });

    return data;
  } catch (error) {
    console.error('Fetch gethistory:', error);
    throw error;
  }
};


export const chatApi = async (text) => {
  try{
      // const token = localStorage.getItem("token");
      //   return await axios.post(`${BASE_URL}/storeuser`,
      //       text,  // Send formData directly here
      //       {
      //         headers: {
      //           'Content-Type': 'application/json',
      //           'Authorization': `Bearer ${token}`
      //         }
      //       }
      //     );
        const message = "Lorem Ipsum is simply dummy text of the printing and typesetting industry.Lorem Ipsum is simply dummy text of the printing and typesetting industry.Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum is simply dummy text of the printing and typesetting industry.Lorem Ipsum is simply dummy text of the printing and typesetting industry.";
        return message;
  } catch(error){
      console.log('error while calling addUser api', error);
  }
}